import React from "react";
import styled from "styled-components";
import { device } from "../../devices";

const AdditionalHeaderTextWrapper = styled.div`
  flex-grow: 1;
`;

const AdditionalTextContent = styled.div`
  color: #1682b1;
  width: 47.5rem;
  line-height: 1.4rem;
  z-index: 10;
  text-align: left;
  font-size: 1rem;
  letter-spacing: 0.7px;
  position: relative;

  @media ${device.mobileScreen} {
    padding: 5px 9px;
    position: relative;
    width: 100%;
    height: auto;
    font-size: 10px;
    font-weight: normal;
    line-height: 1.1rem;
    text-align: center;
    text-indent: 0;
  }

  @media ${device.wideScreen} {
    width: 39rem;
    padding-left: 8px;
    font-size: 12px;
  }
`;

const AdditionalHeaderText = () => {
  return (
    <AdditionalHeaderTextWrapper>
      <AdditionalTextContent>Susținut de 888poker.ro</AdditionalTextContent>
    </AdditionalHeaderTextWrapper>
  );
};

export default AdditionalHeaderText;
